import type { IconProps } from './types';
import './icons.css';

export default function Sorting({
  width,
  height,
  className = '',
}: IconProps): React.JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || 6}
      height={height || 10}
      viewBox="0 0 6 10"
      className={`icon icon-sorting ${className || ''}`}
    >
      <path d="M0 0h2v2H0V0ZM0 4h5v2H0V4ZM0 8h8v2H0z" fill="currentColor" />
    </svg>
  );
}
